var _path, _path2, _path3, _path4, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentageTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6595 6.47897C12.9439 6.08179 13.4014 5.84485 13.8899 5.84168L15.6875 5.83001L17.4761 5.83616C17.9647 5.83784 18.4229 6.07344 18.7085 6.46982L21.7591 10.7033C21.946 10.9626 22.0467 11.2742 22.047 11.5938L22.0563 22.523C22.057 23.366 21.3738 24.0498 20.5308 24.0498H10.8441C10.0008 24.0498 9.31746 23.3655 9.31861 22.5222L9.33362 11.611C9.33405 11.2932 9.43377 10.9834 9.61885 10.7249L12.6595 6.47897Z",
    fill: "white",
    stroke: "#2D2F75",
    strokeWidth: 0.704082
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2587 3.37374C15.7339 3.30334 16.2145 3.46088 16.5558 3.79892L17.8921 5.12242L19.2092 6.45226C19.5472 6.79356 19.7047 7.27413 19.6343 7.74931L18.867 12.9288C18.819 13.253 18.6678 13.5531 18.436 13.7846L10.7989 21.4124C10.2024 22.0082 9.2358 22.0072 8.64056 21.4102L1.57687 14.3255C0.981413 13.7282 0.983536 12.7612 1.58161 12.1665L9.22362 4.56882C9.4547 4.33908 9.75328 4.18937 10.0756 4.14161L15.2587 3.37374Z",
    fill: "white",
    stroke: "#2D2F75",
    strokeWidth: 0.704082
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2138 14.0496C14.2138 14.7186 13.6715 15.2609 13.0024 15.2609C12.3334 15.2609 11.7911 14.7186 11.7911 14.0496C11.7911 13.3805 12.3334 12.8382 13.0024 12.8382C13.6715 12.8382 14.2138 13.3805 14.2138 14.0496Z",
    fill: "#9FC554",
    stroke: "#2D2F75",
    strokeWidth: 0.704082
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7467 10.0294C9.7467 10.6984 9.20435 11.2407 8.53533 11.2407C7.86631 11.2407 7.32396 10.6984 7.32396 10.0294C7.32396 9.36033 7.86631 8.81798 8.53533 8.81798C9.20435 8.81798 9.7467 9.36033 9.7467 10.0294Z",
    fill: "#9FC554",
    stroke: "#2D2F75",
    strokeWidth: 0.704082
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.86548,
    y1: 15.0477,
    x2: 14.0006,
    y2: 8.91261,
    stroke: "#2D2F75",
    strokeWidth: 0.704082,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.1057,
    y1: 4.97043,
    x2: 17.9184,
    y2: 7.70337,
    stroke: "#2D2F75",
    strokeWidth: 0.938775,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.1019,
    y1: 2.65564,
    x2: 16.6068,
    y2: 6.28304,
    stroke: "#2D2F75",
    strokeWidth: 0.938775,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageTagIcon);
export default __webpack_public_path__ + "static/media/percentage-tag-icon.a7b9997d722081e7443964cdd9585315.svg";
export { ForwardRef as ReactComponent };